"use client";

import { useApi } from "@excellent/ui/api";
import {
  modelsConfig,
  type ModelsConfigResponse,
} from "@excellent/ui/api/contracts/models-config";
import { ProvidersSection } from "./_providers";
import { HealthSection } from "./_health";
import { MatrixSection } from "./_matrix";
import { CopilotSection } from "./_copilot";
import { BenchmarkSection } from "./_benchmark";

/**
 * Settings → Models (docs/models/PRD.md §14). One client shell binding the
 * server-rendered initial config to SWR so every section can refetch after a
 * write. Providers · gateway health · per-seam matrix · copilot branch · sweep
 * evidence.
 */
export function ModelsSettingsClient({
  initial,
}: {
  /** Optional SSR seed. SPA host (RO-10-08) loads via useApi only. */
  initial?: ModelsConfigResponse;
}) {
  const cfg = useApi(
    modelsConfig.get,
    {},
    initial ? { fallbackData: initial } : undefined,
  );
  const data = cfg.data ?? initial;
  const refresh = () => {
    void cfg.mutate();
  };

  if (!data) {
    return (
      <p className="type-body text-muted-foreground">Loading models configuration…</p>
    );
  }

  return (
    <div className="flex flex-col gap-8">
      <ProvidersSection data={data} onChange={refresh} />
      <HealthSection />
      <MatrixSection data={data} onChange={refresh} />
      <CopilotSection data={data} onChange={refresh} />
      <BenchmarkSection benchmark={data.benchmark} />
    </div>
  );
}
